import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number to avoid floating-point precision issues.
 * Rounds to specified decimal places and removes trailing zeros.
 */
export function formatNumber(value: number, decimals: number = 2): string {
  const rounded = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
  return rounded.toString()
}

/**
 * Format hours with up to 2 decimal places, removing trailing zeros.
 */
export function formatHours(hours: number): string {
  return formatNumber(hours, 2)
}

/**
 * Format a Date to YYYY-MM-DD string without timezone conversion.
 * This avoids the issue where dates shift due to UTC conversion.
 */
export function formatDateLocal(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

/**
 * Parse a YYYY-MM-DD string as local time, not UTC.
 * This prevents date shifts due to timezone interpretation.
 */
export function parseDateLocal(dateStr: string): Date {
  return new Date(dateStr + "T00:00:00")
}
